import React, { SVGProps } from 'react'
const SvgCheckFilledPurple = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#4F3FDD"
      fillRule="evenodd"
      d="m10.417 3.75.215.003a6.667 6.667 0 1 1-.215-.003Zm3.742 4.111a.625.625 0 0 0-.881.063l-3.879 4.474-1.859-1.991-.068-.063a.625.625 0 0 0-.846.916l2.334 2.5.067.062c.257.206.64.178.862-.08l4.333-5 .056-.074a.625.625 0 0 0-.119-.807Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCheckFilledPurple
